document.addEventListener('DOMContentLoaded', (event) => {
  // Target only the specific container of the list you want to sort
  const itemsContainer = document.querySelector('.collection-list-14.w-dyn-items');
  if (!itemsContainer) return; // Exit if the specific container wasn't found

  // Query only items within the specific container
  const items = Array.from(itemsContainer.querySelectorAll('.w-dyn-item'));

  items.sort((a, b) => {
    const dateA = new Date(a.getAttribute('data-date'));
    const dateB = new Date(b.getAttribute('data-date'));
    return dateB - dateA; // Sort in descending order (newest to oldest)
  });

  items.forEach(item => {
    itemsContainer.appendChild(item); // Re-append items to their container to apply the new order
  });
});
